export default __webpack_public_path__ + "static/media/b7b9c144a9afd145e01749a7a3633a1a.jpg";